import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { getDateFormatLanguage } from '../utils/date';

@Pipe({
  name: 'formatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  transform(dateObject: NgbDate | null, language: string): string {
    if (!dateObject) return 'yyyy-mm-dd';

    const { year, month, day } = dateObject;
    return getDateFormatLanguage({ year, month, day, language });
  }
}
